import "./modal.scss";

import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getFontSizeInRangeLimit } from "../../constants/styles/dimensions";
import { preferencesSelectors } from "../../modules/preferences";
import ToolbarGroup from "../toolbar/ToolbarGroup";
import ToolbarTextButton from "../toolbar/ToolbarTextButton";
import ToolbarTextLabel from "../toolbar/ToolbarTextLabel";
import ToolbarView from "../toolbar/ToolbarView";

const ModalHeading = props => {
  const showLeftButton = props.showCancel || props.showBack;
  const leftText = props.showCancel ? "Cancel" : props.showBack ? "Back" : null;
  const leftClick = props.showCancel ? props.onCancelClick : props.showBack ? props.onBackClick : null;
  const leftIcon = props.showBack ? "leftArrow" : null;

  const rightText = props.showRightButton
    ? props.rightButtonLabel
    : props.showNext
      ? "Next"
      : props.showDone
        ? "Done"
        : null;
  const rightClick = props.showRightButton
    ? props.onRightButtonClick
    : props.showNext
      ? props.onNextClick
      : props.showDone
        ? props.onDoneClick
        : null;

  const rightDisabled = props.showDone ? props.doneDisabled : false;

  const showRightButton = props.showRightButton || props.showNext || props.showDone;

  return (
    <ToolbarView fontSize={getFontSizeInRangeLimit(props.globalFontSize)}>
      <ToolbarGroup position="leftTop" flex={5}>
        {showLeftButton ? (
          <ToolbarTextButton onClick={leftClick} text={leftText} icon={leftIcon} navigateBackStyle={true} />
        ) : null}
      </ToolbarGroup>
      {props.title ? (
        <ToolbarGroup position="centerTop" flex={11}>
          <ToolbarTextLabel text={props.title} />
        </ToolbarGroup>
      ) : null}
      <ToolbarGroup position="right" flex={5}>
        {showRightButton ? (
          <ToolbarTextButton onClick={rightClick} text={rightText} disabled={rightDisabled} navigateBackStyle={true} />
        ) : null}
      </ToolbarGroup>
    </ToolbarView>
  );
};

ModalHeading.propTypes = {
  title: PropTypes.string.isRequired,
  showCancel: PropTypes.bool,
  onCancelClick: PropTypes.func,
  showBack: PropTypes.bool,
  onBackClick: PropTypes.func,
  showNext: PropTypes.bool,
  onNextClick: PropTypes.func,
  showDone: PropTypes.bool,
  onDoneClick: PropTypes.func,
  doneDisabled: PropTypes.bool,
  showRightButton: PropTypes.bool,
  onRightButtonClick: PropTypes.func,
  rightButtonLabel: PropTypes.string,
  globalFontSize: PropTypes.number.isRequired
};

const mapStateToProps = state => {
  return {
    globalFontSize: preferencesSelectors.getGlobalFontSize(state.present)
  };
};

export default connect(mapStateToProps, null)(ModalHeading);
